import React, { useContext } from 'react';
import { ConfigContext } from '../../../../Contexts/ConfigContext';
import InputConfig from '../../../../Components/InputConfig';
import SwitchInput from '../../../../Components/SwitchInput';
import PageHeading from '../../../../Components/PageHeading';

//mui imports====
import useCommonStyles from '../../../../commonStyles';
import { Grid, Paper } from '@mui/material';
//===============

const AutoSkipAdConfig = ({ keyData, featureDescription }) => {
	const commonStyleClasses = useCommonStyles();
	const { rawConfig, updateRawConfig } = useContext(ConfigContext); //rawConfig from ConfigContext
	return (
		<Paper
			style={{ paddingBottom: '6rem' }}
			className={commonStyleClasses.mainPagePaperMarginStyle}
		>
			<PageHeading
				headingName="Auto Skip Ad"
				headingPath={['Dashboard', 'Framerate', 'Features Data', 'Auto Skip Ad']}
				description="Manage Auto Skip Ad Configuration"
				showInfoButton = {true}
				infoMessage={featureDescription}
			/>
			<Grid
				container
				spacing={2}
				className={commonStyleClasses.gridStyles}
				style={{ marginTop: '-2rem', marginLeft: '0rem', width: '90%' }}
			>
				<Grid item xs={2} style={{ marginTop: '4rem' }}>
					<SwitchInput
						keyData={keyData + '.enabled'}
						label="enabled"
						disabled={false}
						defaultChecked={false}
						object={rawConfig}
						updateObject={updateRawConfig}
						containerStyles={{ width: 'fit-content', marginTop: '1rem' }}
					/>
				</Grid>
				<Grid item xs={3.8} style={{ marginTop: '4rem' }}>
					<SwitchInput
						keyData={keyData + '.restartAutoSkipOnInteraction'}
						label="User Interaction Restart"
						disabled={!rawConfig[keyData + '.enabled']}
						defaultChecked={false}
						object={rawConfig}
						updateObject={updateRawConfig}
						containerStyles={{ width: 'fit-content', marginTop: '1rem' }}
					/>
				</Grid>
				<Grid item xs={3}>
					<InputConfig
						label="Autoskip after Seconds"
						keyData={keyData + '.skipAfterSeconds'}
						inputType="number"
						object={rawConfig}
						updateObject={updateRawConfig}
						editable={!!rawConfig[keyData + '.enabled']}
					/>
				</Grid>
				<Grid item xs={3}>
					<InputConfig
						label="Threshold Ad Seconds"
						keyData={keyData + '.thresholdAdSeconds'}
						inputType="number"
						object={rawConfig}
						updateObject={updateRawConfig}
						editable={!!rawConfig[keyData + '.enabled']}
					/>
				</Grid>
			</Grid>
		</Paper>
	);
};
export default AutoSkipAdConfig;
